import { render, staticRenderFns } from "./PublicHeader.vue?vue&type=template&id=4c4da27a&"
import script from "./PublicHeader.vue?vue&type=script&lang=js&"
export * from "./PublicHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports